import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/CheckItemGroupActions";
import * as api from "../../api/CheckItemGroupApi";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";
import { getFilesFromZip } from "../../common";

function* updateCIG(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.updateCIG(action.payload);
        yield put(showSuccessSnackbar(data));
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
    } catch (error) {
        console.log({ error });
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deleteCIG(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.deleteCIG(action.payload);
        yield put(showSuccessSnackbar(data));
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* addCIG(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.addCIG(action.payload);
        yield put(showSuccessSnackbar(data));
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
    } catch (error) {
        console.log({ error });
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getList(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getList(action.payload);
        yield put(actions.setList(data || undefined));
    } catch (error) {
        yield put(actions.setList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getCheckItemsByGroup(action) {
    try {
        const { data } = yield api.getCheckItemsByGroup(action.payload);
        yield put(actions.setCheckItemsByGroup(data || undefined));
    } catch (error) {
        yield put(actions.setCheckItemsByGroup(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

// for check items

function* updateCI(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.updateCI(action.payload);
        yield put(showSuccessSnackbar(data));
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
    } catch (error) {
        console.log({ error });
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deleteCI(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.deleteCI(action.payload);
        yield put(showSuccessSnackbar(data));
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* addCI(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.addCI(action.payload);
        yield put(showSuccessSnackbar(data));
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
    } catch (error) {
        console.log({ error });
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getListOfItems() {
    try {
        const { data } = yield api.getListOfItems();
        yield put(actions.setListOfItems(data || undefined));
    } catch (error) {
        yield put(actions.setListOfItems(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

// planned maintenance

function* updatePlannedCIG(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.updatePlannedCIG(action.payload);
        yield put(showSuccessSnackbar(data));
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
    } catch (error) {
        console.log({ error });
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deletePlannedCIG(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.deletePlannedCIG(action.payload);
        yield put(showSuccessSnackbar(data));
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* addPlannedCIG(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.addPlannedCIG(action.payload);
        yield put(showSuccessSnackbar(data));
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
    } catch (error) {
        console.log({ error });
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getPlannedList(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getPlannedList(action.payload);
        yield put(actions.setPlannedList(data || undefined));
    } catch (error) {
        yield put(actions.setPlannedList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getPlannedCheckItemsByGroup(action) {
    try {
        const { data } = yield api.getPlannedCheckItemsByGroup(action.payload);
        yield put(actions.setPlannedCheckItemsByGroup(data || undefined));
    } catch (error) {
        yield put(actions.setPlannedCheckItemsByGroup(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

// for check items

function* updatePlannedCI(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.updatePlannedCI(action.payload);
        yield put(showSuccessSnackbar(data));
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
    } catch (error) {
        console.log({ error });
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deletePlannedCI(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.deletePlannedCI(action.payload);
        yield put(showSuccessSnackbar(data));
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* addPlannedCI(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.addPlannedCI(action.payload);
        yield put(showSuccessSnackbar(data));
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getPlannedListOfItems() {
    try {
        const { data } = yield api.getPlannedListOfItems();
        yield put(actions.setPlannedListOfItems(data || undefined));
    } catch (error) {
        yield put(actions.setPlannedListOfItems(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getPlannedCheckItemFiles(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getPlannedCheckItemFiles(action.payload);
        console.log({ data });
        const files = yield getFilesFromZip(data);
        console.log({ files });
        yield put(actions.setPlannedCheckItemFiles(files || undefined));
    } catch (error) {
        yield put(actions.setPlannedCheckItemFiles(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* addPlannedCheckItemFiles(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.addPlannedCheckItemFiles(action.payload);
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deletePlannedCheckItemFiles(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.deletePlannedCheckItemFiles(action.payload);
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getAutonomousCheckItemFiles(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getAutonomousCheckItemFiles(action.payload);
        console.log({ data });
        const files = yield getFilesFromZip(data);
        console.log({ files });
        yield put(actions.setAutonomousCheckItemFiles(files || undefined));
    } catch (error) {
        yield put(actions.setAutonomousCheckItemFiles(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* addAutonomousCheckItemFiles(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.addAutonomousCheckItemFiles(action.payload);
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deleteAutonomousCheckItemFiles(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.deleteAutonomousCheckItemFiles(action.payload);
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.CIG_UPDATE, updateCIG);
    yield takeEvery(actions.Types.CIG_DELETE, deleteCIG);
    yield takeEvery(actions.Types.CIG_CREATE, addCIG);
    yield takeEvery(actions.Types.GET_ITEMGROUPLIST, getList);
    yield takeEvery(actions.Types.GET_ITEMSBYGROUP, getCheckItemsByGroup);
    // for check items
    yield takeEvery(actions.Types.CI_UPDATE, updateCI);
    yield takeEvery(actions.Types.CI_DELETE, deleteCI);
    yield takeEvery(actions.Types.CI_CREATE, addCI);
    yield takeEvery(actions.Types.GET_ITEMLIST, getListOfItems);
    yield takeEvery(actions.Types.PLANNED_CIG_UPDATE, updatePlannedCIG);
    yield takeEvery(actions.Types.PLANNED_CIG_DELETE, deletePlannedCIG);
    yield takeEvery(actions.Types.PLANNED_CIG_CREATE, addPlannedCIG);
    yield takeEvery(actions.Types.GET_PLANNED_ITEMGROUPLIST, getPlannedList);
    yield takeEvery(actions.Types.GET_PLANNED_ITEMSBYGROUP, getPlannedCheckItemsByGroup);
    // for check items
    yield takeEvery(actions.Types.PLANNED_CI_UPDATE, updatePlannedCI);
    yield takeEvery(actions.Types.PLANNED_CI_DELETE, deletePlannedCI);
    yield takeEvery(actions.Types.PLANNED_CI_CREATE, addPlannedCI);
    yield takeEvery(actions.Types.GET_PLANNED_ITEMLIST, getPlannedListOfItems);
    yield takeEvery(actions.Types.GET_PLANNED_CHECK_ITEM_FILES, getPlannedCheckItemFiles);
    yield takeEvery(actions.Types.POST_PLANNED_CHECK_ITEM_FILES, addPlannedCheckItemFiles);
    yield takeEvery(actions.Types.DELETE_PLANNED_CHECK_ITEM_FILES, deletePlannedCheckItemFiles);
    yield takeEvery(actions.Types.GET_AUTONOMOUS_CHECK_ITEM_FILES, getAutonomousCheckItemFiles);
    yield takeEvery(actions.Types.POST_AUTONOMOUS_CHECK_ITEM_FILES, addAutonomousCheckItemFiles);
    yield takeEvery(actions.Types.DELETE_AUTONOMOUS_CHECK_ITEM_FILES, deleteAutonomousCheckItemFiles);
}

const CheckItemGroupSaga = [fork(watchAll)];

export default CheckItemGroupSaga;
